<template>
    <div class="modal fade" tabindex="-1" :id="id">
      <div class="modal-dialog modal-lg">
        <form @submit.prevent="submitForm" class="form mt-5" >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ edit ? $t('settings.eventStatus.update') : $t('settings.eventStatus.create') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="closeModal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor"/>
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor"/>
                    </svg>
                </span>
              </div>
            </div>
            <div class="modal-body">
              <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold mb-5">
                <li class="nav-item mt-2" @click="toggleTab(formTab.creation)">
                  <a class="nav-link text-active-primary ms-0 me-10 py-3" :class="{'active' : (currentTab === formTab.creation || !currentTab) }"  data-bs-toggle="tab" :href="'#'+formTab.creation">
                    {{ $t('events.status.info') }}
                  </a>
                </li>
                <li class="nav-item mt-2" @click.prevent="formData.name && toggleTab(formTab.permission)">
                  <a class="nav-link text-active-primary ms-0 me-10 py-3" :class="{'active' : currentTab === formTab.permission, 'disabled': !formData.name  }" data-bs-toggle="tab" :href="'#'+formTab.permission">
                    {{ $t('events.status.permissions') }}
                  </a>
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show" :class="{'active' : (currentTab === formTab.creation || !currentTab) }" :id="formTab.creation" role="tabpanel">
                  <RequiredText />
                  <div class="row">
                    <Input
                        containerClass="col-12 mt-auto mb-5"
                        :name="`${id}-status-name`"
                        type="text"
                        :label="$t('events.participator.statusName')"
                        labelClass="form-label fs-6 text-black"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        :isRequired="true"
                        size="lg"
                        v-model="formData.name"
                    />
                    <div class="form-group">
                      <label class="form-label fs-6 text-black">{{ $t('events.participator.statusDesc') }}</label>
                      <textarea :name="'description'+id" v-model="formData.description" class="form-control form-control-solid" rows="3"></textarea>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade show" :class="{'active' : currentTab === formTab.permission }" :id="formTab.creation" role="tabpanel">
                  <div class="row">
                    <div class="form-group col-12 col-md-6 col-lg-6" v-for="permission in permissions" :key="permission.index">
                      <div class="card shadow-sm p-3 col-12 mb-4">
                        <div class="row">
                          <label class="col-10 col-form-label">{{ permission.permission[locale] }}</label>
                          <div class="col-2 switch-btn mt-3">
                            <span class="switch switch-icon">
                              <label>
                                <div class="form-check form-switch form-check-custom form-check-solid">
                                  <input
                                      class="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      :name="permission.value"
                                      v-model="formData.permission_ids[permission.id]"
                                      id="flexSwitchChecked"
                                  />
                                </div>
                              </label>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div><!--  -->
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <Button v-if="currentTab === formTab.creation || !currentTab" btn-class="btn-sm me-2" type="cancel" btn-text="button.close" size="7px 30px" @click.prevent="closeModal"/>
              <Button v-if="currentTab === formTab.permission" btn-class="btn-sm me-2" type="cancel" btn-text="button.prev" size="7px 30px" @click.prevent="() => toggleTab()"/>
              <Button v-if="currentTab === formTab.creation || !currentTab" :is-disabled="!formData.name" btn-class="btn-sm me-2" type="new" btn-text="button.next" size="7px 30px" @click.prevent="() => toggleTab()"/>
              <Button v-if="currentTab === formTab.permission" btn-class="btn-sm me-3" type="submit" id="submit_btn" :is-disabled="!formData.name" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script setup>
  
  import {computed, defineProps, reactive, ref, watch, onMounted} from 'vue';
  import { useStore } from "vuex";
  import Button from "@/components/Button.vue"
  import Input from "@/components/Input.vue";
  import {useLocales} from "@/composables/locales";
  import RequiredText from "@/components/RequiredText.vue";
  
  const { locale } = useLocales()
  const store = useStore()
  
  const emit = defineEmits(['created'])
  const props = defineProps({
    data:{
      type:Object,
      default: () => ({
        id: "",
        name: "",
        description: "",
        permission_ids: {}
      })
    },
    id: String,
    edit: {
        type: Boolean,
        default: false
    }
  })
  
  const formTab = reactive({
    creation: "Creation",
    permission: "Permission",
  })

  const formData = ref(props.data)
  const isLoading = ref(false)
  const currentTab = ref('')
  
  const permissions = computed(() => store.getters['events/getEventPermissions'])
  
  watch(() => props.data, (value) => {
    formData.value = props.data
  }, { deep: true })
  
  function toggleTab(tabId){
    if(tabId) {
      currentTab.value = tabId
    }else {
      currentTab.value =
          currentTab.value === formTab.creation
              ? formTab.permission
              : formTab.creation
    }
  }
  
  function closeModal(){
    $('#'+props.id).modal('toggle')
  }

  function submitForm() {
    isLoading.value = true
    formData.value.permission_ids = Object.entries(formData.value.permission_ids)
        .filter(([_, value]) => value)
        .map(([key]) => key)

    let action = props.edit ? 'eventStatus/updateEventStatus' : 'eventStatus/createEventStatus'

    store.dispatch(action, formData.value)
        .then(res => {
          window.toastr.success(i18n.global.t("notification.event_status_created"))
          emit('created')
          isLoading.value = false
          $('#'+props.id).modal('toggle')
          formData.value= {
            name: "",
            description: "",
            permission_ids: {}
          }
          currentTab.value = formTab.creation
        })
        .finally(() => isLoading.value = false)
  }
  
  onMounted(() => {
    store.dispatch('events/loadEventPermissions')
  })
</script>
  